module.exports = require("core-js/library/fn/set");


//////////////////
// WEBPACK FOOTER
// ../~/@babel/runtime-corejs2/core-js/set.js
// module id = 234
// module chunks = 1